<form [formGroup]="dealForm" (ngSubmit)="onSubmit()" autocomplete="off" class="h-100">
  <p-popover #combinedEligibilityPopover [dismissable]="false" appendTo="body" [autoZIndex]="true" [baseZIndex]="10000">
    <div class="p-2" style="max-width: 420px">
      <p class="mb-2 fw-500">This deal violates the following rule(s):</p>
      <ul class="mb-2 ps-3">
        @for (rule of combinedEligibilityRulesMessage(); track rule) {
          <li>{{ rule }}</li>
        }
      </ul>
    </div>
  </p-popover>
  <div class="row h-100 overflow-y-auto row-gap-3 row-gap-xl-0">
    <!-- Left Column: Deals Summary -->
    <div class="col-12 col-lg-4 col-xl-3 col-xl1-2 creat-deals-height order-1 order-lg-0">
      <div class="bg-white border rounded-4 p-3 h-100 shadow-sm d-flex flex-column">
        <h3 class="fs-5 fw-500 text-dark mb-4 mt-1">APS Summary</h3>
        @if (
          selected.salesOffice() ||
          selected.prospect() ||
          selected.project() ||
          selected.model() ||
          selected.lot() ||
          selected.elevation() ||
          selected.realtorAgent()
        ) {
          <div class="d-flex flex-column gap-3 flex-fill overflow-y-auto pe-3 me-n3 scroll-deals-sides">
            <!-- Sales Office -->
            <div class="row gy-3">
              @if (selected.salesOffice()) {
                <div class="col-lg-12 col-md-6">
                  <div class="d-flex align-items-start gap-3 p-3 bg-light rounded-3 h-100">
                    <i class="bi bi-building fs-5 text-muted"></i>
                    <div class="flex-fill">
                      <div class="text-muted small mb-1">Sales Office</div>
                      @if (selected.salesOffice()) {
                        <div class="fw-500 text-dark">{{ selected.salesOffice()!.name }}</div>
                      } @else {
                        <div class="text-muted">-</div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (selectedProjectData()) {
                <!-- Project -->
                <div class="col-lg-12 col-md-6">
                  <div class="d-flex align-items-start gap-3 p-3 bg-light rounded-3 h-100">
                    <i class="bi bi-folder fs-5 text-muted"></i>
                    <div class="flex-fill">
                      <div class="text-muted small mb-1">Project</div>
                      @if (selectedProjectData()) {
                        <div class="fw-500 text-dark">{{ selectedProjectData()!.projectName }}</div>
                        <div class="small text-muted">{{ selectedProjectData()!.projectCode }}</div>
                      } @else {
                        <div class="text-muted">-</div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (selected.prospect()) {
                <!-- Prospect -->
                <div class="col-lg-12 col-md-6">
                  <div class="d-flex align-items-start gap-3 p-3 bg-light rounded-3 h-100">
                    <i class="bi bi-person fs-5 text-muted"></i>
                    <div class="flex-fill">
                      <div class="text-muted small mb-1">Prospect</div>
                      @if (selected.prospect()) {
                        <div class="fw-500 text-dark">{{ selectedProspectFullName() }}</div>
                        <div class="small text-muted text-break">{{ selected.prospect()!.email }}</div>
                        <div class="small text-muted">{{ selectedProspectPhone() }}</div>
                      } @else {
                        <div class="text-muted">-</div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (selectedLotData()) {
                <!-- Lot -->
                <div class="col-lg-12 col-md-6">
                  <div class="d-flex align-items-start gap-3 p-3 bg-light rounded-3 h-100">
                    <i class="bi bi bi-pin-map fs-5 text-muted"></i>
                    <div class="flex-fill">
                      <div class="text-muted small mb-1">Lot</div>
                      @if (selectedLotData()) {
                        <div class="fw-500 text-dark">{{ selectedLotData()!.lotNo }}</div>
                      } @else {
                        <div class="text-muted">-</div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (selected.model()) {
                <!-- Model -->
                <div class="col-lg-12 col-md-6">
                  <div class="d-flex align-items-start gap-3 p-3 bg-light rounded-3 h-100">
                    <i class="bi bi-boxes fs-5 text-muted"></i>
                    <div class="flex-fill">
                      <div class="text-muted small mb-1">Model</div>
                      @if (selected.model()) {
                        <div class="fw-500 text-dark">{{ selected.model()!.modelName }}</div>
                        <div class="small text-muted">{{ selected.model()!.scheduleCode }}</div>
                      } @else {
                        <div class="text-muted">-</div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (selected.elevation()) {
                <!-- Elevation -->
                <div class="col-lg-12 col-md-6">
                  <div class="d-flex align-items-start gap-3 p-3 bg-light rounded-3 h-100">
                    <i class="bi bi-buildings fs-5 text-muted"></i>
                    <div class="flex-fill">
                      <div class="text-muted small mb-1">Elevation</div>
                      @if (selected.elevation()) {
                        <div class="fw-500 text-dark">{{ selected.elevation()!.elevationCode }}</div>
                        <div class="small text-muted">{{ selected.elevation()!.description }}</div>
                      } @else {
                        <div class="text-muted">-</div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (selected.realtorAgent()) {
                <!-- Realtor Agent -->
                <div class="col-lg-12 col-md-6">
                  <div class="d-flex align-items-start gap-3 p-3 bg-light rounded-3 h-100">
                    <i class="bi bi-person-lines-fill fs-5 text-muted"></i>
                    <div class="flex-fill">
                      <div class="text-muted small mb-1">Realtor Agent</div>
                      @if (selected.realtorAgent()) {
                        <div class="fw-500 text-dark">
                          {{ selected.realtorAgent()!.firstName }} {{ selected.realtorAgent()!.lastName }}
                        </div>
                        <div class="small text-muted">{{ selected.realtorAgent()!.email }}</div>
                        <div class="small text-muted">
                          @if (selected.realtorAgent()!.phones && selected.realtorAgent()!.phones.length > 0) {
                            {{ selected.realtorAgent()!.phones[0]!.phoneNumber }}
                          } @else {
                            <div class="text-muted"></div>
                          }
                        </div>
                      } @else {
                        <div class="text-muted">-</div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        } @else {
          <div class="d-flex flex-column flex-fill justify-content-center text-center bg-light rounded-4 p-3">
            <i class="bi bi-tag text-muted fs-48"></i>
            <h3 class="text-muted mb-2">No APS created</h3>
            <p class="text-muted small">to create APS select values from create APS</p>
          </div>
        }
      </div>
    </div>

    <!-- Middle Column: Enter Details -->
    <div
      class="col-12 col-lg col-xl1 creat-deals-height order-0 deal-steps-col"
      [ngClass]="selected.prospect() ? 'col-xl-6' : 'col-xl'"
    >
      <div class="bg-white border rounded-4 p-3 h-100 shadow-sm d-flex flex-column">
        <div class="d-flex align-items-center gap-3 mb-3">
          <i class="bi bi-tag fs-28 me-2"></i>
          <div>
            <h3 class="fs-24 fw-500 text-dark mb-0">Complete the steps below</h3>
            <p class="text-muted fs-16 mb-0">Select your project, lot, model, and elevation to create a APS</p>
          </div>
        </div>
        @if (eligibilityResult() && !eligibilityResult()!.isEligible && combinedEligibilityRulesMessage().length > 0) {
          <p-message
            severity="warn"
            icon="pi pi-exclamation-triangle"
            text="Violations: {{ combinedEligibilityRulesMessage().length }} rule(s) violated"
            styleClass="mb-3"
            (mouseover)="showCombinedEligibilityRules($event)"
            (mouseout)="hideCombinedEligibilityRules()"
          />
        }
        @for (moved of lotWarnings.value()?.paperworkOnMovedDeals ?? []; track moved.dealId) {
          <p-message severity="warn" icon="pi pi-exclamation-triangle" styleClass="mb-2">
            <span class="fs-14">
              A signed {{ moved.documents.join(', ') }} for this lot is on {{ moved.buyerName ?? 'a deal' }}'s deal
              (moved to lot {{ moved.newLotNo }}). Make sure it's amended before selling.
              <ng-container [ngTemplateOutlet]="openDealLink" [ngTemplateOutletContext]="{ $implicit: moved.dealId }" />
            </span>
          </p-message>
        }
        @for (group of cancelledDealDeposits(); track group.dealId) {
          @if (!canUseLeftoverDeposits()) {
            <p-message severity="warn" icon="pi pi-exclamation-triangle" styleClass="mb-2">
              <span class="fs-14">
                This lot holds {{ group.count }} deposit(s) from {{ group.buyerName ?? 'another deal' }}'s deal.
                <ng-container
                  [ngTemplateOutlet]="openDealLink"
                  [ngTemplateOutletContext]="{ $implicit: group.dealId }"
                />
              </span>
            </p-message>
          } @else {
            @if (unpaidDepositIds(group).length > 0) {
              <p-message severity="warn" icon="pi pi-exclamation-triangle" styleClass="mb-2">
                <span class="d-flex flex-wrap align-items-center gap-2 fs-14">
                  <label class="d-flex align-items-center gap-2 mb-0">
                    <p-checkbox
                      [binary]="true"
                      [ngModelOptions]="{ standalone: true }"
                      [ngModel]="isUsingDeposits(group)"
                      (ngModelChange)="setUsingDeposits(group, $event)"
                    ></p-checkbox>
                    Use these {{ unpaidDepositIds(group).length }} deposit(s) ({{
                      unpaidDepositsTotal(group) | currencyFormat
                    }}) from {{ group.buyerName ?? 'another deal' }}'s deal for this deal
                  </label>
                  <ng-container
                    [ngTemplateOutlet]="openDealLink"
                    [ngTemplateOutletContext]="{ $implicit: group.dealId }"
                  />
                </span>
              </p-message>
            }
            @if (group.paidDepositIds.length > 0) {
              <p-message severity="warn" icon="pi pi-exclamation-triangle" styleClass="mb-2">
                <span class="fs-14">
                  {{ group.paidDepositIds.length }} deposit(s) with payments stay with
                  {{ group.buyerName ?? 'another deal' }}'s deal. Ask finance to sort them out.
                  <ng-container
                    [ngTemplateOutlet]="openDealLink"
                    [ngTemplateOutletContext]="{ $implicit: group.dealId }"
                  />
                </span>
              </p-message>
            }
          }
        }
        <div class="flex-fill h-100 me-n3 overflow-y-auto pe-3">
          <p-accordion [value]="activePanel()" (valueChange)="activePanel.set(String($event))">
            <!-- Step 1: Select Prospect -->
            <div class="bg-white rounded-3 mb-3">
              <p-accordion-panel value="1">
                <p-accordion-header
                  [ngClass]="selected.prospect() ? 'border border-success border-1' : 'border border-1'"
                >
                  <div class="d-flex align-items-center w-100">
                    <div
                      class="align-items-center bg-info-subtle d-flex justify-content-center me-3 p-2 rounded-2 lh-1 wh-40"
                    >
                      <i class="bi bi-person"></i>
                    </div>
                    <div class="flex-fill">
                      <div class="d-flex align-items-center mb-1">
                        <h6 class="mb-0 fw-500 text-black me-2">Select Prospect</h6>
                        <!-- <button type="button" class="btn btn-primary btn-h42 ms-auto" (click)="addProspect()"> -->
                        <i
                          class="bi bi-person-plus fs-20 me-2 cursor-pointer"
                          (click)="addProspect()"
                          title="Add New Prospect"
                        ></i>
                        <!-- </button> -->
                      </div>
                      <p class="fw-400 m-0 text-body-secondary small">{{ selectedProspectFullName() }}</p>
                      <!-- <p class="fw-400 m-0 text-body-secondary small">[{{ filteredProspects().length }}] available</p> -->
                    </div>
                    @if (selected.prospect()) {
                      <i class="bi bi-check-circle me-3 fs-24 text-success"></i>
                    }
                  </div>
                </p-accordion-header>
                <p-accordion-content>
                  <div class="row mb-3">
                    <div class="col-lg-4">
                      <div class="position-relative">
                        <svg-icon
                          [name]="'search-topbar'"
                          class="position-absolute top-50 start-0 translate-middle-y ms-3 svg-16"
                        ></svg-icon>
                        <input
                          type="text"
                          class="form-control py-2 ps-5 rounded-5"
                          placeholder="Search prospects..."
                          (input)="searchTerms.prospect.set($any($event.target).value)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column mxh-350 overflow-y-auto">
                    <div class="table-theme table-outer">
                      <div class="table-responsive mxh-350">
                        <p-table [value]="filteredProspects()">
                          <ng-template #header>
                            <tr>
                              <th pSortableColumn="fullName">Full Name <p-sortIcon field="fullName" /></th>
                              <th pSortableColumn="email">Email <p-sortIcon field="email" /></th>
                              <th pSortableColumn="phones">Phone <p-sortIcon field="phones" /></th>
                            </tr>
                          </ng-template>
                          <ng-template #body let-prospect>
                            <tr
                              [class.box-selected]="selected.prospect()?.id === prospect.id"
                              (click)="onProspectSelect(prospect)"
                            >
                              <td>{{ prospect.fullName }}</td>
                              <td>
                                <a
                                  (click)="stopPropagation($event)"
                                  href="mailto:{{ prospect.email }}"
                                  class="text-decoration-none text-primary"
                                  >{{ prospect.email }}</a
                                >
                              </td>
                              <td>
                                <phone-numbers-display (click)="stopPropagation($event)" [contacts]="prospect.phones" />
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="3" class="text-center py-4">
                                <span class="text-muted">No prospects available</span>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </div>
                  </div>
                </p-accordion-content>
              </p-accordion-panel>
            </div>

            <!-- Step 2: Select Lot -->
            <div class="bg-white rounded-3 mb-3" [class.box-disabled]="!selected.project()">
              <p-accordion-panel
                value="2"
                [ngClass]="combinedEligibilityRulesMessage().length > 0 ? 'violation-header' : ''"
              >
                <p-accordion-header [ngClass]="selected.lot() ? 'border border-success border-1' : 'border border-1'">
                  <div class="d-flex align-items-center w-100">
                    <div
                      class="align-items-center bg-info-subtle d-flex justify-content-center me-3 p-2 rounded-2 lh-1 wh-40"
                    >
                      <i class="bi bi-pin-map"></i>
                    </div>
                    <div class="flex-fill">
                      <div class="d-flex align-items-center mb-1">
                        <h6 class="mb-0 fw-500 text-black">Select Lot</h6>
                      </div>
                      <!-- <p class="fw-400 m-0 text-body-secondary small">[{{ filteredLots().length }}] available</p> -->
                      <p class="fw-400 m-0 text-body-secondary small">{{ selectedLotData()?.lotNo }}</p>
                    </div>
                    <i
                      class="pi pi-exclamation-circle me-3 fs-24 text-warning"
                      [ngClass]="combinedEligibilityRulesMessage().length > 0 ? '' : 'd-none'"
                    ></i>
                    @if (selected.lot() && combinedEligibilityRulesMessage().length === 0) {
                      <i class="bi bi-check-circle me-3 fs-24 text-success"></i>
                    }
                  </div>
                </p-accordion-header>
                <p-accordion-content>
                  @if (selected.project()) {
                    <div class="row mb-3">
                      <div class="col-lg-4">
                        <div class="position-relative">
                          <svg-icon
                            [name]="'search-topbar'"
                            class="position-absolute top-50 start-0 translate-middle-y ms-3 svg-16"
                          ></svg-icon>
                          <input
                            type="text"
                            class="form-control py-2 ps-5 rounded-5"
                            placeholder="Search lots..."
                            (input)="searchTerms.lot.set($any($event.target).value)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="align-items-center flex-wrap d-grid gap-2 me-n2 pe-2">
                      <div class="table-theme table-outer">
                        <div class="table-responsive mxh-350">
                          <p-table [value]="filteredLots()">
                            <ng-template #header>
                              <tr>
                                <th pSortableColumn="lotNo">Lot No <p-sortIcon field="lotNo" /></th>
                                <th pSortableColumn="descr">Description <p-sortIcon field="descr" /></th>
                                <th pSortableColumn="lotTypeName">Lot Type <p-sortIcon field="lotTypeName" /></th>
                                <th pSortableColumn="address.cityName">City <p-sortIcon field="address.cityName" /></th>
                                <th pSortableColumn="statusName">Lot Status <p-sortIcon field="statusName" /></th>
                              </tr>
                            </ng-template>
                            <ng-template #body let-lot>
                              <tr [class.box-selected]="selected.lot() === lot.id" (click)="onLotSelect(lot)">
                                <td>{{ lot.lotNo }}</td>
                                <td>{{ lot.descr }}</td>
                                <td>{{ lot.lotTypeName }}</td>
                                <td>{{ lot.address?.cityName }}</td>
                                <td>{{ lot.statusName }}</td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="5" class="text-center py-4">
                                  <span class="text-muted">No lots available for selected project</span>
                                </td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                    </div>
                  } @else {
                    <div class="text-center py-4">
                      <p class="text-muted">Please select a project first</p>
                    </div>
                  }
                </p-accordion-content>
              </p-accordion-panel>
            </div>

            <!-- Step 3: Select Model (panel value kept as 4 for existing flow) -->
            <div class="bg-white rounded-3 mb-3" [class.box-disabled]="!selected.lot()">
              <p-accordion-panel
                value="4"
                [ngClass]="combinedEligibilityRulesMessage().length > 0 ? 'violation-header' : ''"
              >
                <p-accordion-header [ngClass]="selected.model() ? 'border border-success border-1' : 'border border-1'">
                  <div class="d-flex align-items-center w-100">
                    <div
                      class="align-items-center bg-info-subtle d-flex justify-content-center me-3 p-2 rounded-2 lh-1 wh-40"
                    >
                      <i class="bi bi-boxes"></i>
                    </div>
                    <div class="flex-fill">
                      <div class="d-flex align-items-center mb-1">
                        <h6 class="mb-0 fw-500 text-black">Select Model</h6>
                      </div>
                      <!-- <p class="fw-400 m-0 text-body-secondary small">[{{ filteredModels().length }}] available</p> -->
                      <p class="fw-400 m-0 text-body-secondary small">{{ selectedModelData() }}</p>
                    </div>
                    <i
                      class="bi bi-exclamation-circle me-3 fs-24 text-warning"
                      [ngClass]="combinedEligibilityRulesMessage().length > 0 ? '' : 'd-none'"
                    ></i>
                    @if (selected.model() && combinedEligibilityRulesMessage().length === 0) {
                      <i class="bi bi-check-circle me-3 fs-24 text-success"></i>
                    }
                  </div>
                </p-accordion-header>
                <p-accordion-content>
                  @if (selected.lot()) {
                    <div class="row mb-3">
                      <div class="col-lg-4">
                        <div class="position-relative">
                          <svg-icon
                            [name]="'search-topbar'"
                            class="position-absolute top-50 start-0 translate-middle-y ms-3 svg-16"
                          ></svg-icon>
                          <input
                            type="text"
                            class="form-control py-2 ps-5 rounded-5"
                            placeholder="Search models..."
                            (input)="searchTerms.model.set($any($event.target).value)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="align-items-center flex-wrap d-grid gap-2 me-n2 pe-2">
                      <div class="d-flex flex-column mxh-350 overflow-y-auto">
                        <div class="table-theme table-outer">
                          <div class="table-responsive mxh-350">
                            <p-table [value]="filteredModels()">
                              <ng-template #header>
                                <tr>
                                  <th pSortableColumn="modelName">Model Name <p-sortIcon field="modelName" /></th>
                                  <th pSortableColumn="notes">Notes <p-sortIcon field="notes" /></th>
                                  <th pSortableColumn="style">Style <p-sortIcon field="style" /></th>
                                  <th pSortableColumn="bedrooms">Bedrooms <p-sortIcon field="bedrooms" /></th>
                                  <!-- <th>Violated Rules</th> -->
                                </tr>
                              </ng-template>
                              <ng-template #body let-model>
                                <tr
                                  [class.box-selected]="selected.model()?.id === model.id"
                                  (click)="onModelSelect(model)"
                                >
                                  <td>{{ model.modelName }}</td>
                                  <td>{{ model.notes }}</td>
                                  <td>{{ model.style }}</td>
                                  <td>{{ model.bedrooms }}</td>
                                </tr>
                              </ng-template>
                              <ng-template pTemplate="emptymessage">
                                <tr>
                                  <td colspan="5" class="text-center py-4">
                                    <span class="text-muted">No models available for selected lot</span>
                                  </td>
                                </tr>
                              </ng-template>
                            </p-table>
                          </div>
                        </div>
                      </div>
                    </div>
                  } @else {
                    <div class="text-center py-4">
                      <p class="text-muted">Please select a lot first</p>
                    </div>
                  }
                </p-accordion-content>
              </p-accordion-panel>
            </div>

            <!-- Step 4: Select Elevation (panel value kept as 5 for existing flow) -->
            <div class="bg-white rounded-3 mb-3" [class.box-disabled]="!selected.model()">
              <p-accordion-panel
                value="5"
                [ngClass]="combinedEligibilityRulesMessage().length > 0 ? 'violation-header' : ''"
              >
                <p-accordion-header
                  [ngClass]="selected.elevation() ? 'border border-success border-1' : 'border border-1'"
                >
                  <div class="d-flex align-items-center w-100">
                    <div
                      class="align-items-center bg-info-subtle d-flex justify-content-center me-3 p-2 rounded-2 lh-1 wh-40"
                    >
                      <i class="bi bi-buildings"></i>
                    </div>
                    <div class="flex-fill">
                      <div class="d-flex align-items-center mb-1">
                        <h6 class="mb-0 fw-500 text-black">Select Elevation</h6>
                      </div>
                      <!-- <p class="fw-400 m-0 text-body-secondary small">[{{ filteredElevations().length }}] available</p> -->
                      <p class="fw-400 m-0 text-body-secondary small">{{ selectedElevationData() }}</p>
                    </div>
                    <i
                      class="pi pi-exclamation-circle me-3 fs-24 text-warning"
                      [ngClass]="combinedEligibilityRulesMessage().length > 0 ? '' : 'd-none'"
                    ></i>
                    @if (selected.elevation() && combinedEligibilityRulesMessage().length === 0) {
                      <i class="bi bi-check-circle me-3 fs-24 text-success"></i>
                    }
                  </div>
                </p-accordion-header>
                <p-accordion-content>
                  @if (selected.model()) {
                    <div class="row mb-3">
                      <div class="col-lg-4">
                        <div class="position-relative">
                          <svg-icon
                            [name]="'search-topbar'"
                            class="position-absolute top-50 start-0 translate-middle-y ms-3 svg-16"
                          ></svg-icon>
                          <input
                            type="text"
                            class="form-control py-2 ps-5 rounded-5"
                            placeholder="Search elevations..."
                            (input)="searchTerms.elevation.set($any($event.target).value)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="align-items-center flex-wrap d-grid gap-2 me-n2 pe-2">
                      <div class="table-theme table-outer">
                        <div class="table-responsive mxh-350">
                          <p-table [value]="filteredElevations()">
                            <ng-template #header>
                              <tr>
                                <th pSortableColumn="elevationCode">
                                  Elevation Code <p-sortIcon field="elevationCode" />
                                </th>
                                <th pSortableColumn="description">Description <p-sortIcon field="description" /></th>
                                <th pSortableColumn="area">Area <p-sortIcon field="area" /></th>
                                <!-- <th>Violated Rules</th> -->
                              </tr>
                            </ng-template>
                            <ng-template #body let-elevation>
                              <tr
                                [class.box-selected]="selected.elevation()?.id === elevation.elevationId"
                                (click)="onElevationSelect(elevation)"
                              >
                                <td>{{ elevation.elevationCode }}</td>
                                <td>{{ elevation.description }}</td>
                                <td>{{ elevation.area }}</td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="4" class="text-center py-4">
                                  <span class="text-muted">No elevations available for selected model</span>
                                </td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                    </div>
                  } @else {
                    <div class="text-center py-4">
                      <p class="text-muted">Please select a model first</p>
                    </div>
                  }
                </p-accordion-content>
              </p-accordion-panel>
            </div>

            <!-- Step 5: Select Realtor Agent (panel value kept as 6 for existing flow) -->
            <div class="bg-white rounded-3" [class.box-disabled]="!selected.model()">
              <p-accordion-panel value="6">
                <p-accordion-header
                  [ngClass]="selected.realtorAgent() ? 'border border-success border-1' : 'border border-1'"
                >
                  <div class="d-flex align-items-center w-100">
                    <div
                      class="align-items-center bg-info-subtle d-flex justify-content-center me-3 p-2 rounded-2 lh-1 wh-40"
                    >
                      <i class="bi bi-person"></i>
                    </div>
                    <div class="flex-fill">
                      <div class="d-flex align-items-center mb-1">
                        <h6 class="mb-0 fw-500 text-black">Select Realtor Agent</h6>
                      </div>
                      <!-- <p class="fw-400 m-0 text-body-secondary small">[{{ filteredElevations().length }}] available</p> -->
                      <p class="fw-400 m-0 text-body-secondary small">{{ selectedRealtorAgentData() }}</p>
                    </div>
                    @if (selected.realtorAgent()) {
                      <i class="bi bi-check-circle me-3 fs-24 text-success"></i>
                    }
                  </div>
                </p-accordion-header>
                <p-accordion-content>
                  @if (selected.model()) {
                    <div class="row mb-3">
                      <div class="col-lg-4">
                        <div class="position-relative">
                          <svg-icon
                            [name]="'search-topbar'"
                            class="position-absolute top-50 start-0 translate-middle-y ms-3 svg-16"
                          ></svg-icon>
                          <input
                            type="text"
                            class="form-control py-2 ps-5 rounded-5"
                            placeholder="Search realtor agents..."
                            (input)="searchTerms.realtorAgent.set($any($event.target).value)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="align-items-center flex-wrap d-grid gap-2 me-n2 pe-2">
                      <div class="table-theme table-outer">
                        <div class="table-responsive mxh-350">
                          <p-table [value]="filteredRealtorAgents()">
                            <ng-template #header>
                              <tr>
                                <th pSortableColumn="firstName">Realtor Agent Name <p-sortIcon field="firstName" /></th>
                                <th pSortableColumn="email">Email <p-sortIcon field="email" /></th>
                                <th>Phone</th>
                              </tr>
                            </ng-template>
                            <ng-template #body let-realtorAgent>
                              <tr
                                [class.box-selected]="selected.realtorAgent()?.id === realtorAgent.id"
                                (click)="onRealtorAgentSelect(realtorAgent)"
                              >
                                <td>{{ realtorAgent.firstName }} {{ realtorAgent.lastName }}</td>
                                <td>
                                  <!-- (click)="stopPropagation($event)" -->
                                  <a href="mailto:{{ realtorAgent.email }}" class="text-decoration-none text-primary">{{
                                    realtorAgent.email
                                  }}</a>
                                </td>
                                <td>
                                  <!-- (click)="stopPropagation($event)" -->
                                  <phone-numbers-display [contacts]="realtorAgent.phones" />
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="3" class="text-center py-4">
                                  <span class="text-muted">No realtor agents available for selected model</span>
                                </td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                    </div>
                  } @else {
                    <div class="text-center py-4">
                      <p class="text-muted">Please select a model first to select a realtor agent</p>
                    </div>
                  }
                </p-accordion-content>
              </p-accordion-panel>
            </div>
          </p-accordion>
        </div>
      </div>
    </div>

    <!-- Right Column: Past Deals -->
    @if (selected.prospect() && prospectDeals().length > 0) {
      <div class="col-12 col-xl-3 col-xl1-2 order-2 creat-deals-height past-deals-col">
        <div class="bg-white border rounded-4 p-3 h-100 shadow-sm d-flex flex-column">
          <h3 class="fs-5 fw-500 text-dark mb-2"><i class="bi bi-clock-history me-2"></i> Past APS</h3>
          <p class="text-muted fs-16 mb-3">
            @if (selected.prospect()) {
              <span>{{ selectedProspectFullName() }}'s APS history</span>
            } @else {
              <span>Prospect APS history</span>
            }
          </p>

          <div class="flex-fill overflow-y-auto pe-3 me-n3 scroll-deals-sides pt-1">
            <div class="d-flex flex-column gap-3 h-100">
              @if (prospectDeals().length > 0) {
                @for (deal of prospectDeals(); track deal.id) {
                  <div class="border rounded-3 p-3 cursor-pointer deal-card-hover" (click)="navigateToDealDetail(deal)">
                    <div class="d-flex justify-content-between align-items-start mb-2">
                      <div>
                        <div class="fw-500 text-dark">{{ deal.lot.projectCode }}</div>
                        <div class="small text-muted">{{ deal.lot.lotNo }}</div>
                      </div>
                      @if (deal.dealStatus) {
                        <span [class]="getStatusClass(deal.dealStatus.name)">{{ deal.dealStatus.name }}</span>
                      }
                    </div>

                    <div class="small mb-2">
                      <div class="text-muted mb-1">Model/Elevation:</div>
                      <div class="fw-500">
                        {{ deal.lot.selectedModel?.modelName }} - {{ deal.lot.selectedElevation?.elevationCode }}
                      </div>
                    </div>
                    <div class="small">
                      <div class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Contract Date:</span>
                        <span class="fw-500">{{
                          deal.contract?.contractDate ? (deal.contract?.contractDate | date: 'shortDate') : '-'
                        }}</span>
                      </div>
                      <div class="d-flex justify-content-between">
                        <span class="text-muted">Target Date:</span>
                        <span class="fw-500">{{
                          deal.contract?.targetClosingDate
                            ? (deal.contract?.targetClosingDate | date: 'shortDate')
                            : '-'
                        }}</span>
                      </div>
                    </div>
                  </div>
                }
              } @else {
                <div class="d-flex flex-column flex-fill justify-content-center text-center bg-light rounded-4 p-3">
                  <i class="bi bi-file-earmark-text text-muted fs-48"></i>
                  <h3 class="text-muted mb-2">No past APS</h3>
                  <p class="text-muted small">Select a prospect to view their APS history</p>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</form>

<p-confirmdialog> </p-confirmdialog>

<ng-template #addProspectModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header pt-3 pb-0">
      <h2 class="modal-title">Add Prospect</h2>
      <span (click)="modal.dismiss()" role="button" class="ms-auto">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
  </div>
  <div class="modal-body modal-body-fixed overflow-y-auto">
    <prospect-form
      [scanCards]="false"
      [onSubmit]="onSubmit$"
      (reload)="closeProspectsResource()"
      [enableCardScan]="false"
    ></prospect-form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close')">Close</button>
    <button type="button" class="btn btn-primary" (click)="onSubmitSubject.next()">Submit</button>
  </div>
</ng-template>

<ng-template #openDealLink let-dealId>
  <a [href]="'/sales/aps/' + dealId + '/overview'" target="_blank" rel="noopener" class="fw-600 text-nowrap"
    >Open deal <i class="pi pi-external-link fs-12"></i
  ></a>
</ng-template>
